import contract from '@mailobj-browser/front/js/contracts/contract.js'
import array from '@mailobj-browser/front/js/utils/array.js'
import clear from './clear.js'
import draw from './draw.js'
import hr from './hr.js'
import ol from './ol.js'
import redo from './redo.js'
import ul from './ul.js'
import undo from './undo.js'
import removeFormat from './removeFormat.js'
import signature from './signature.js'
import template from './template.js'
import link from './link.js'
import table from './table.js'
import image from './image/image.js'

export default contract({
  clear: array([
    clear
  ]),
  draw: array([
    draw
  ]),
  hr: array([
    hr
  ]),
  image,
  link: array([
    link
  ]),
  ol: array([
    ol
  ]),
  redo: array([
    redo
  ]),
  removeFormat: array([
    removeFormat
  ]),
  signature: array([
    signature
  ]),
  table: array([
    table
  ]),
  template: array([
    template
  ]),
  ul: array([
    ul
  ]),
  undo: array([
    undo
  ])
})
